import api from "./apiClient";

/* ===================================================== */
/* 🔧 ERROR NORMALIZER                                   */
/* ===================================================== */

function normalizeError(err, fallbackMessage) {
  return new Error(
    err?.response?.data?.message ||
      err?.message ||
      fallbackMessage
  );
}

/* ===================================================== */
/* 📊 DEFAULT SAFE RESPONSE                              */
/* Prevent UI crashes                                    */
/* ===================================================== */

function getDefaultReport() {
  return {
    project: {},
    tasks: {
      total: 0,
      completed: 0,
      pending: 0,
      overdue: 0,
      byPhase: [],
    },
    milestones: {
      total: 0,
      overdue: 0,
      upcoming: 0,
      latest: [],
    },
  };
}

/* ===================================================== */
/* GET PROJECT REPORT                                    */
/* GET /reports/projects/:projectId                      */
/* ===================================================== */

export const getProjectReport = async (projectId) => {
  if (!projectId) {
    throw new Error("Project ID is required");
  }

  try {
    const { data } = await api.get(
      `/reports/projects/${projectId}`
    );

    return data || getDefaultReport();
  } catch (err) {
    throw normalizeError(err, "Failed to fetch project report");
  }
};

/* ===================================================== */
/* BACKWARD COMPATIBILITY                                */
/* ===================================================== */

export const getProjectSummary = (projectId) =>
  getProjectReport(projectId);

/* ===================================================== */
/* FUTURE FEATURES (SAFE PLACEHOLDERS)                   */
/* ===================================================== */

export const getWeeklyReport = async () => {
  throw new Error(
    "Weekly report not implemented yet"
  );
};

export const exportReport = async () => {
  throw new Error(
    "Export report not implemented yet"
  );
};

export const sendReportEmail = async () => {
  throw new Error(
    "Send report email not implemented yet"
  );
};

/* ===================================================== */
/* EXPORT                                                */
/* ===================================================== */

const reportService = {
  getProjectReport,
  getProjectSummary,
  getWeeklyReport,
  exportReport,
  sendReportEmail,
};

export default reportService;